import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@env/environment';

import { BaoyingModule } from './app/baoying.module';

if (environment.app.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(BaoyingModule)
  .catch((err) => console.error(err));
